export default __webpack_public_path__ + "static/media/einzig_wahre_full.9333129b.png";